import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import type { AppState, AppThunk } from '../../store'

import { GetUser } from '@/src/api/user'
import { SetOrderTrackNo } from '@/src/api/track'

import { TRACK_LIST_KEY, TRACK_LIMIT_AMOUNT, TRACK_LIST_ARCHIVE_KEY } from '@/src/redux/features/trackLocal/trackLocalSlice'

export interface UserState {
  userInfo: any
  memberInfo: any
  trackLimitAmount: number
  status: 'idle' | 'loading' | 'succeeded' | 'failed',
  isBuyer: boolean,
  value: number,
  isLogin: boolean
}

const initialState: UserState = {
  userInfo: {},
  memberInfo: { ml: 0 },
  trackLimitAmount: TRACK_LIMIT_AMOUNT, // 最大追踪数，匿名40，免费会员40，基础会员100，高级会员200
  status: 'loading',
  isBuyer: false,
  isLogin: false,
  value: 1
}

export const queryUser = createAsyncThunk(
  'user/queryUser',
  async () => {
    const res = await GetUser()
    // 用户登录 && 是buyer角色
    if (res.Json && res.Json.gid && res.Json.FUserRole === 4) {
      // 同步运单号 
      try {
        await syncLockTrack()
        return res
      } catch (error) {
        console.log('error', error)
        return res
      }
    }
    return res
  }
)

const delayDo = (getState: any, callback: Function, time?: number) => {
  const state = getState().user
  if (state.status === 'loading') {
    const setTimeOutTime = setTimeout(() => {
      delayDo(getState, callback, time)
      clearTimeout(setTimeOutTime)
    }, time || 100)
  } else {
    callback(state)
    return 
  }
}

/**
* 同步单号
* @param tracks {Array}
*  no      单号
*  rm      备注
*  w1      第一运输商
*  w2      第二运输商
*  ts      追踪状态类型  0 无效追踪 1 待追踪 2 正在追踪 3 已完成
*  ot      操作类型      1 新增 2 修改 4 删除
*  isa     是否归档
*  totop   置顶的时间戳
*/
const initTrackSyncData = (activeList: any, archiveList: any) => {
  const activeArr = activeList.map((item: any) => {
    return {
      no: item.num,
      rm: '',
      w1: '',
      w2: '',
      ot: 1,
      isa: false,
      totop: ''
    }
  })
  const archiveArr = archiveList.map((item: any) => {
    return {
      no: item.num,
      rm: '',
      w1: '',
      w2: '',
      ot: 1,
      isa: true,
      totop: ''
    }
  })
  return activeArr.concat(archiveArr)
}

// 同步本地单号
const syncLockTrack = async () => {
  const ActiveTrack = JSON.parse(window.localStorage.getItem(TRACK_LIST_KEY) || '[]') // 激活数据
  const ArchiveTrack = JSON.parse(window.localStorage.getItem(TRACK_LIST_ARCHIVE_KEY) || '[]') // 归档
  const params = initTrackSyncData(ActiveTrack, ArchiveTrack)
  if (params && params.length) {
    // console.log('正在同步运单', params)
    await SetOrderTrackNo(params)
    try {
      window.localStorage.setItem(TRACK_LIST_KEY, '[]')
      window.localStorage.setItem(TRACK_LIST_ARCHIVE_KEY, '[]')
    } catch (error) {
      console.log(error)
    }
    
    return true
  }
  return true
}

export const userSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    
  },
  extraReducers(builder) {
    builder
      .addCase(queryUser.pending, (state) => {
        state.status = 'loading'
        // console.log(state.status, action)
      })
      .addCase(queryUser.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // console.log(state.status, action)
        const res = action.payload
        const Json = res.Json || {}
        if (Json && Json.gid) {
          const ms = (Json.ms || [])[0]
          const isBuyer = res.Json.FUserRole === 4
          state.userInfo = res.Json
          state.isBuyer = isBuyer
          state.memberInfo = ms || {}
          state.isLogin = true
        } else {
          // 未登录
          state.userInfo = {}
          state.isBuyer = false
          state.isLogin = false
          // console.log(res.Message || '')
        }
      })
      .addCase(queryUser.rejected, (state) => {
        state.status = 'failed'
        // console.log(state.status, action)
      })
  }
})

// export const { incrementByAmount } = userSlice.actions

export const getUserInfo = (state: AppState) => state.user.userInfo

export const getIsBuyer = (state: AppState) => state.user.isBuyer

export const getUserState = (state: AppState) => state.user


export const userInfoSync = (callback: Function): AppThunk =>
  (dispatch, getState) => {
    // console.log(getState().user)
    delayDo(getState, callback)
  }

// export const getIsBuyer = (callback: Function): AppThunk =>
// (dispatch, getState) => {
//   delayDo(getState, (callBackState: UserState) => {
//     const isBuyer = callBackState.userInfo.FUserRole === 4
//     callback(isBuyer)
//   })
// }


export default userSlice.reducer
